'use client';

const MainTabsUnderbar = ({
  underbarWidthAndPosition,
}: {
  underbarWidthAndPosition: { xPosition: number; width: number };
}) => {
  return (
    <div
      className='absolute bottom-0 flex justify-center transition-all h-2pxr'
      style={{
        transform: `translateX(${underbarWidthAndPosition.xPosition}px)`,
        width: `${underbarWidthAndPosition.width}px`,
      }}
    >
      <div className='w-full h-2pxr bg-new-point-500'></div>
    </div>
  );
};

export default MainTabsUnderbar;
